/* eslint-disable class-methods-use-this */
import { EntityDto, PagedResultDto } from '@services';
import http from '../httpService';
import {
  CreateInspection,
  CreateInspectionResponses,
  CreateInspectionTenant,
  Inspection,
  InspectionCategory,
  PagedInspectionRequest,
  UpdateInspection,
} from './inspection';

class InspectionService {
  public async getAll(request: PagedInspectionRequest): Promise<PagedResultDto<Inspection>> {
    const result = await http.get('api/services/app/Inspection/GetAll', {
      params: request,
    });
    return result.data.result;
  }

  public async get(entityDto: EntityDto<string>): Promise<Inspection> {
    const result = await http.get('api/services/app/Inspection/Get', { params: entityDto });
    return result.data.result;
  }

  public async getAllCategories(tenantId: number): Promise<InspectionCategory[]> {
    const result = await http.get(
      `api/services/app/Inspection/GetAllCategories?tenantId=${tenantId}`
    );
    return result.data.result;
  }

  public async getAllCategoriesByTenantId(tenantId: number): Promise<InspectionCategory[]> {
    const result = await http.get(
      `api/services/app/Inspection/GetAllCategoriesByTenantId?tenantId=${tenantId}`
    );
    return result.data.result;
  }

  public async create(request: CreateInspection): Promise<Inspection> {
    const result = await http.post('api/services/app/Inspection/Create', request);
    return result.data.result;
  }

  public async update(inspection: UpdateInspection): Promise<Inspection> {
    const result = await http.put('api/services/app/Inspection/Update', inspection);
    return result.data.result;
  }

  public async publish(id: EntityDto<string>): Promise<Inspection> {
    const result = await http.post('api/services/app/Inspection/Publish', id);
    return result.data.result;
  }

  public async createInspectionTenant(request: CreateInspectionTenant): Promise<void> {
    const result = await http.post('api/services/app/Inspection/CreateInspectionTenant', request);
    return result.data.result;
  }

  public async createResponses(request: CreateInspectionResponses): Promise<Inspection> {
    const result = await http.post(
      'api/services/app/Inspection/CreateInspectionResponses',
      request
    );
    return result.data.result;
  }

  public async createOrderInspection({
    categoryId,
    orderId,
  }: {
    categoryId: number;
    orderId: string;
  }): Promise<Inspection> {
    const result = await http.post('api/services/app/Inspection/CreateOrderInspection', {
      categoryId,
      orderId,
    });
    return result.data.result;
  }

  public async sendInspectionEmail(id: string, email?: string): Promise<void> {
    await http.post('api/services/app/Inspection/SendInspectionEmail', { id, email });
  }

  public async deleteOrderInspection({
    categoryId,
    orderId,
  }: {
    categoryId: number;
    orderId: string;
  }): Promise<string> {
    const result = await http.post('api/services/app/Inspection/DeleteOrderInspection', {
      categoryId,
      orderId,
    });
    return result.data.result;
  }
}

export default new InspectionService();
